<script setup>
  import { useSlots } from "vue";
  import TooltipPrimitive from "./TooltipPrimitive.vue";
  import TooltipContent from "./TooltipContent.vue";
  import TooltipProvider from "./TooltipProvider.vue";
  import TooltipTrigger from "./TooltipTrigger.vue";

  defineProps({
    content: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    asChild: {
      type: Boolean,
      default: true,
    },
    delayDuration: {
      type: Number,
      default: 0,
    },
    triggerClass: {
      type: String,
      default: "!cursor-default",
    },
    side: {
      type: String,
      default: "top",
      validator: (value) => ["top", "right", "bottom", "left"].includes(value),
    },
    contentClass: {
      type: String,
      default: "",
    },
  });

  const slots = useSlots();
</script>

<template>
  <span
    v-if="disabled"
    class="contents">
    <slot />
  </span>

  <TooltipProvider
    v-else
    :delay-duration="delayDuration">
    <TooltipPrimitive>
      <TooltipTrigger
        :as-child="asChild"
        :class="triggerClass">
        <slot />
      </TooltipTrigger>
      <TooltipContent
        :class="['text-xs', contentClass]"
        :side="side">
        <slot
          v-if="slots.content"
          name="content" />
        <template v-else>{{ content }}</template>
      </TooltipContent>
    </TooltipPrimitive>
  </TooltipProvider>
</template>
